module.exports = __webpack_public_path__ + "img/shani-standing.545a793e.png";